import { render } from "./SignRiskProfileReportSection.vue?vue&type=template&id=0b22e5d9"
import script from "./SignRiskProfileReportSection.vue?vue&type=script&lang=js"
export * from "./SignRiskProfileReportSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__